exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinnerContainer{display:flex;justify-content:center;align-items:center;backdrop-filter:blur(5px);width:100%;height:100%;position:absolute;top:0;left:0;z-index:99}", ""]);

